import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Categories from './pages/Categories';
import Partnership from './pages/Partnership';
import About from './pages/About';
import WhyChoose from './pages/WhyChoose';
import Contact from './pages/Contact';
import WhatsAppButton from './components/WhatsAppButton';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/partnership" element={<Partnership />} />
          <Route path="/about" element={<About />} />
          <Route path="/why-choose" element={<WhyChoose />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
